import { getGifDurationInSeconds } from '@remotion/gif';
import { Dimensions } from '@remotion/layout-utils';
import { DropPosition } from '../../assets/add-asset';
import { GifAsset } from '../../assets/assets';
import { byDefaultKeepAspectRatioMap } from '../../utils/aspect-ratio';
import { calculateMediaDimensionsForCanvas } from '../../utils/dimension-utils';
import { generateRandomId } from '../../utils/generate-random-id';
import { GifItem } from './gif-item-type';

export const makeGifItem = async ({
  file,
  currentFrame,
  dropPosition,
  dimensions,
  assetId,
  blobUrl,
  fps,
  compositionWidth,
  compositionHeight,
  filename,
  remoteUrl,
  remoteFileKey,
  durationInSeconds,
}: {
  file: Blob;
  currentFrame: number;
  dropPosition: DropPosition | null;
  dimensions: Dimensions;
  assetId: string;
  blobUrl: string;
  fps: number;
  compositionWidth: number;
  compositionHeight: number;
  remoteUrl: string | null;
  remoteFileKey: string | null;
  filename: string;
  /** 아이템 duration 고정값 (선택, 없으면 GIF 실제 재생 시간) */
  durationInSeconds?: number;
}): Promise<{ item: GifItem; asset: GifAsset }> => {
  const id = generateRandomId();
  const gifDuration = await getGifDurationInSeconds(blobUrl);
  const actualDuration = durationInSeconds ?? gifDuration;

  const durationInFrames = Math.floor(actualDuration * fps);

  const content = calculateMediaDimensionsForCanvas({
    mediaWidth: dimensions.width,
    mediaHeight: dimensions.height,
    containerWidth: compositionWidth,
    containerHeight: compositionHeight,
    dropPosition,
  });

  const asset: GifAsset = {
    id: assetId,
    type: 'gif',
    durationInSeconds: gifDuration,
    filename: filename,
    remoteUrl,
    remoteFileKey,
    size: file.size,
    mimeType: file.type,
    width: dimensions.width,
    height: dimensions.height,
  };

  const item: GifItem = {
    id,
    durationInFrames,
    gifStartFromInSeconds: 0,
    top: content.top,
    left: content.left,
    width: content.width,
    height: content.height,
    from: currentFrame,
    type: 'gif',
    opacity: 1,
    borderRadius: 0,
    rotation: 0,
    playbackRate: 1,
    assetId: asset.id,
    isDraggingInTimeline: false,
    keepAspectRatio: byDefaultKeepAspectRatioMap.gif,
    fadeInDurationInSeconds: 0,
    fadeOutDurationInSeconds: 0,
    cropLeft: 0,
    cropTop: 0,
    cropRight: 0,
    cropBottom: 0,
  };

  return { item, asset };
};
